import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_BASKETS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/baskets`;

export const ADMIN_BASKETS_API_PATHS = {
  GET_BASKETS: `${ADMIN_BASKETS_API_ROOT}`,
  GET_BASKET_BY_ID: (basketId: string) => `${ADMIN_BASKETS_API_ROOT}/${basketId}`,
  CREATE_BASKET: `${ADMIN_BASKETS_API_ROOT}`,
  UPDATE_BASKET: (basketId: string) => `${ADMIN_BASKETS_API_ROOT}/${basketId}`,
  ARCHIVE_BASKET: (basketId: string) => `${ADMIN_BASKETS_API_ROOT}/${basketId}`,
  RESTORE_BASKET: (basketId: string) => `${ADMIN_BASKETS_API_ROOT}/${basketId}/restore`,
  UPDATE_POSITIONS: `${ADMIN_BASKETS_API_ROOT}/positions`,
  GET_UPLOAD_URL: `${ADMIN_BASKETS_API_ROOT}/upload-url`,
};
